var React = require('react');

function IconSearch (props) {
    return React.createElement("svg",props,React.createElement("g",{"stroke":"none","fill":"currentColor"},React.createElement("path",{"d":"M8.3099521,6.89573854 L11.7071068,10.2928932 C12.0976311,10.6834175 12.0976311,11.3165825 11.7071068,11.7071068 C11.3165825,12.0976311 10.6834175,12.0976311 10.2928932,11.7071068 L6.89573854,8.3099521 C6.20201398,8.74709153 5.38054196,9 4.5,9 C2.01471863,9 0,6.98528137 0,4.5 C0,2.01471863 2.01471863,0 4.5,0 C6.98528137,0 9,2.01471863 9,4.5 C9,5.38054196 8.74709153,6.20201398 8.3099521,6.89573854 L8.3099521,6.89573854 Z M4.5,7 C5.88071187,7 7,5.88071187 7,4.5 C7,3.11928813 5.88071187,2 4.5,2 C3.11928813,2 2,3.11928813 2,4.5 C2,5.88071187 3.11928813,7 4.5,7 Z"})));
}

IconSearch.defaultProps = {"viewBox":"0 0 14 14"};

module.exports = IconSearch;

IconSearch.default = IconSearch;
